import { atom } from 'jotai';

import type { NodesDefinition } from '@src/scenario-editor/render-utils/types';

export const nodeDefinitionsAtom = atom<NodesDefinition>({});
